// =============================================
// MOCK 模式 - 所有接口返回本地假数据，无需后端
// =============================================
const delay = (ms = 300) => new Promise(res => setTimeout(res, ms));
const mock = (data) => delay().then(() => data);

// ---- Mock 数据源 ----
let _domainId = 10;
const _domains = [
  { id: 1, name: '内容审核-图文', description: '图文内容的机审评测，覆盖违规文字、涉政、色情等类目', gmtCreate: '2024-09-10 10:00:00', gmtModified: '2024-12-01 14:30:00' },
  { id: 2, name: '内容审核-视频', description: '短视频帧级违规检测评测，包含暴力、色情、版权侵权场景', gmtCreate: '2024-10-05 09:15:00', gmtModified: '2025-01-08 11:20:00' },
  { id: 3, name: '采购合规审核', description: '企业采购单据合规性自动化审核，结合规则引擎与LLM双引擎', gmtCreate: '2024-11-20 16:00:00', gmtModified: '2025-02-14 09:00:00' },
  { id: 4, name: '合同要素抽取', description: '合同文本关键要素（甲方、乙方、金额、日期）的智能抽取评测', gmtCreate: '2025-01-03 08:30:00', gmtModified: '2025-03-01 10:45:00' },
  { id: 5, name: '智能客服QA', description: '机器人问答质量评测，包含意图识别准确率与回复相关性', gmtCreate: '2025-02-18 11:00:00', gmtModified: '2025-03-20 15:10:00' },
];

// 业务域管理API
export const businessDomainApi = {
  getList: (params) => {
    const { pageNo = 1, pageSize = 10, name } = params || {};
    let list = [..._domains];
    if (name) list = list.filter(d => d.name.includes(name));
    const start = (pageNo - 1) * pageSize;
    return mock({ total: list.length, list: list.slice(start, start + pageSize) });
  },
  getDetail: (id) => mock(_domains.find(d => d.id === +id) || _domains[0]),
  create: (data) => {
    const item = { id: ++_domainId, ...data, gmtCreate: new Date().toLocaleString('zh-CN'), gmtModified: new Date().toLocaleString('zh-CN') };
    _domains.push(item);
    return mock(item);
  },
  update: (id, data) => {
    const idx = _domains.findIndex(d => d.id === +id);
    if (idx >= 0) Object.assign(_domains[idx], data, { gmtModified: new Date().toLocaleString('zh-CN') });
    return mock(_domains[idx]);
  },
  delete: (id) => { const idx = _domains.findIndex(d => d.id === +id); if (idx >= 0) _domains.splice(idx, 1); return mock(true); },
};

let _scenarioId = 20;
const _scenarios = [
  { id: 1, name: '采购RT审核-图文', description: '采购场景图文内容实时审核', domainId: 1, domainName: '内容审核-图文', scenarioType: 'AUTO_REVIEW', gmtCreate: '2024-09-15 10:00:00', gmtModified: '2024-12-10 11:00:00' },
  { id: 2, name: '合同违规文字检测', description: '合同文本中违禁词、违规表述检测', domainId: 1, domainName: '内容审核-图文', scenarioType: 'AUTO_REVIEW', gmtCreate: '2024-10-01 14:00:00', gmtModified: '2025-01-05 09:30:00' },
  { id: 3, name: '短视频暴力内容检测', description: '视频帧级暴力、血腥内容识别', domainId: 2, domainName: '内容审核-视频', scenarioType: 'AUTO_REVIEW', gmtCreate: '2024-10-20 09:00:00', gmtModified: '2025-01-15 16:00:00' },
  { id: 4, name: '采购单合规性验证', description: '采购单必填字段、金额阈值、审批链验证', domainId: 3, domainName: '采购合规审核', scenarioType: 'FEATURE_EXTRACTION', gmtCreate: '2024-11-25 10:00:00', gmtModified: '2025-02-20 14:00:00' },
  { id: 5, name: '合同甲乙方抽取', description: '从合同文本中提取甲方、乙方、签约日期信息', domainId: 4, domainName: '合同要素抽取', scenarioType: 'FEATURE_EXTRACTION', gmtCreate: '2025-01-08 09:00:00', gmtModified: '2025-03-05 10:30:00' },
  { id: 6, name: '合同金额与条款抽取', description: '合同总金额、付款条款、违约金条款抽取', domainId: 4, domainName: '合同要素抽取', scenarioType: 'FEATURE_EXTRACTION', gmtCreate: '2025-01-10 10:00:00', gmtModified: '2025-03-08 11:00:00' },
  { id: 7, name: '售后问答-退换货', description: '退换货政策问答意图识别与回复质量评测', domainId: 5, domainName: '智能客服QA', scenarioType: 'ROBOT_QA', gmtCreate: '2025-02-20 11:00:00', gmtModified: '2025-03-25 15:00:00' },
  { id: 8, name: '售后问答-物流查询', description: '物流状态查询类问答准确率评测', domainId: 5, domainName: '智能客服QA', scenarioType: 'ROBOT_QA', gmtCreate: '2025-02-25 14:00:00', gmtModified: '2025-03-28 09:00:00' },
];

// 业务场景管理API
export const businessScenarioApi = {
  getList: (params) => {
    const { pageNo = 1, pageSize = 10, name, domainId } = params || {};
    let list = [..._scenarios];
    if (name) list = list.filter(s => s.name.includes(name));
    if (domainId) list = list.filter(s => s.domainId === +domainId);
    const start = (pageNo - 1) * pageSize;
    return mock({ total: list.length, list: list.slice(start, start + pageSize) });
  },
  getDetail: (id) => mock(_scenarios.find(s => s.id === +id) || _scenarios[0]),
  create: (data) => {
    const domain = _domains.find(d => d.id === +data.domainId);
    const item = { id: ++_scenarioId, ...data, domainName: domain?.name || '', gmtCreate: new Date().toLocaleString('zh-CN'), gmtModified: new Date().toLocaleString('zh-CN') };
    _scenarios.push(item);
    return mock(item);
  },
  update: (id, data) => {
    const idx = _scenarios.findIndex(s => s.id === +id);
    if (idx >= 0) Object.assign(_scenarios[idx], data, { gmtModified: new Date().toLocaleString('zh-CN') });
    return mock(_scenarios[idx]);
  },
  delete: (id) => { const idx = _scenarios.findIndex(s => s.id === +id); if (idx >= 0) _scenarios.splice(idx, 1); return mock(true); },
  getListByDomain: (domainId) => mock(_scenarios.filter(s => s.domainId === +domainId).map(s => ({ text: s.name, value: s.id }))),
};

let _judgeSetId = 30;
const _judgeSets = [
  { id: 1, name: '采购审核基础集-v1', description: '覆盖采购单基本合规场景，共200条用例', scenarioId: 1, scenarioName: '采购RT审核-图文', useCaseCount: 200, gmtCreate: '2024-10-01 09:00:00', gmtModified: '2025-01-10 10:00:00' },
  { id: 2, name: '合同要素抽取集-v2', description: '包含甲乙方、金额、日期标准抽取用例', scenarioId: 5, scenarioName: '合同甲乙方抽取', useCaseCount: 150, gmtCreate: '2025-01-15 11:00:00', gmtModified: '2025-03-10 14:00:00' },
  { id: 3, name: '视频违规检测集-v1', description: '暴力/血腥/色情视频帧检测用例集', scenarioId: 3, scenarioName: '短视频暴力内容检测', useCaseCount: 320, gmtCreate: '2024-11-05 14:00:00', gmtModified: '2025-02-01 09:30:00' },
  { id: 4, name: '客服QA退换货集', description: '退换货场景问答标准答案集', scenarioId: 7, scenarioName: '售后问答-退换货', useCaseCount: 80, gmtCreate: '2025-02-28 10:00:00', gmtModified: '2025-03-30 16:00:00' },
];

// 评测集管理API
export const judgeSetApi = {
  getList: (params) => {
    const { pageNo = 1, pageSize = 10, name, scenarioId } = params || {};
    let list = [..._judgeSets];
    if (name) list = list.filter(j => j.name.includes(name));
    if (scenarioId) list = list.filter(j => j.scenarioId === +scenarioId);
    const start = (pageNo - 1) * pageSize;
    return mock({ total: list.length, list: list.slice(start, start + pageSize) });
  },
  getDetail: (id) => mock(_judgeSets.find(j => j.id === +id) || _judgeSets[0]),
  create: (data) => { const item = { id: ++_judgeSetId, ...data, useCaseCount: 0, gmtCreate: new Date().toLocaleString('zh-CN'), gmtModified: new Date().toLocaleString('zh-CN') }; _judgeSets.push(item); return mock(item); },
  update: (id, data) => { const idx = _judgeSets.findIndex(j => j.id === +id); if (idx >= 0) Object.assign(_judgeSets[idx], data); return mock(_judgeSets[idx]); },
  delete: (id) => { const idx = _judgeSets.findIndex(j => j.id === +id); if (idx >= 0) _judgeSets.splice(idx, 1); return mock(true); },
  getCases: (judgeSetId, params) => {
    const { pageNo = 1, pageSize = 10 } = params || {};
    const cases = _useCases.filter(c => c.judgeSetIds?.includes(+judgeSetId));
    const start = (pageNo - 1) * pageSize;
    return mock({ total: cases.length, list: cases.slice(start, start + pageSize) });
  },
  saveCases: (judgeSetId, data) => mock(true),
  removeCases: (judgeSetId, data) => mock(true),
  getAssociatedCaseIds: (judgeSetId) => mock([1, 2, 3]),
};

let _useCaseId = 100;
const _useCases = [
  { id: 1, name: '采购单-金额超限用例', scenarioId: 1, scenarioName: '采购RT审核-图文', judgeSetIds: [1], actualData: '{"amount": 500000, "approver": null}', expectedAnswer: '{"violation": true, "reason": "金额超过审批阈值且审批人为空"}', status: 'ACTIVE', fileType: 'JSON', gmtCreate: '2024-10-05 10:00:00' },
  { id: 2, name: '采购单-正常合规用例', scenarioId: 1, scenarioName: '采购RT审核-图文', judgeSetIds: [1], actualData: '{"amount": 8000, "approver": "张三", "department": "采购部"}', expectedAnswer: '{"violation": false}', status: 'ACTIVE', fileType: 'JSON', gmtCreate: '2024-10-06 11:00:00' },
  { id: 3, name: '合同-甲乙方标准抽取', scenarioId: 5, scenarioName: '合同甲乙方抽取', judgeSetIds: [2], actualData: '本合同由甲方：阿里巴巴（中国）有限公司，乙方：浙江XX科技有限公司于2025年1月签订。', expectedAnswer: '{"party_a": "阿里巴巴（中国）有限公司", "party_b": "浙江XX科技有限公司", "sign_date": "2025-01-01"}', status: 'ACTIVE', fileType: 'TEXT', gmtCreate: '2025-01-20 09:00:00' },
  { id: 4, name: '视频帧-暴力画面', scenarioId: 3, scenarioName: '短视频暴力内容检测', judgeSetIds: [3], actualData: 'frame_001.jpg', expectedAnswer: '{"label": "violence", "confidence": 0.96}', status: 'ACTIVE', fileType: 'IMAGE', gmtCreate: '2024-11-10 14:00:00' },
  { id: 5, name: '退换货-7天无理由', scenarioId: 7, scenarioName: '售后问答-退换货', judgeSetIds: [4], actualData: '我买的商品到了3天，想退货可以吗？', expectedAnswer: '您好，我们支持7天无理由退货，您的商品在有效期内，可以直接在订单页面申请退货。', status: 'ACTIVE', fileType: 'TEXT', gmtCreate: '2025-03-01 10:00:00' },
  { id: 6, name: '合同金额-大额条款抽取', scenarioId: 6, scenarioName: '合同金额与条款抽取', judgeSetIds: [2], actualData: '合同总金额为人民币壹佰万元整（¥1,000,000），分三期付款。', expectedAnswer: '{"total_amount": 1000000, "currency": "CNY", "payment_terms": "分三期付款"}', status: 'ACTIVE', fileType: 'TEXT', gmtCreate: '2025-01-25 15:00:00' },
];

// 用例管理API
export const useCaseApi = {
  getList: (params) => {
    const { pageNo = 1, pageSize = 10, name, scenarioId, judgeSetId } = params || {};
    let list = [..._useCases];
    if (name) list = list.filter(c => c.name.includes(name));
    if (scenarioId) list = list.filter(c => c.scenarioId === +scenarioId);
    if (judgeSetId) list = list.filter(c => c.judgeSetIds?.includes(+judgeSetId));
    const start = (pageNo - 1) * pageSize;
    return mock({ total: list.length, list: list.slice(start, start + pageSize) });
  },
  getDetail: (id) => mock(_useCases.find(c => c.id === +id) || _useCases[0]),
  create: (data) => { const item = { id: ++_useCaseId, ...data, gmtCreate: new Date().toLocaleString('zh-CN') }; _useCases.push(item); return mock(item); },
  update: (id, data) => { const idx = _useCases.findIndex(c => c.id === +id); if (idx >= 0) Object.assign(_useCases[idx], data); return mock(_useCases[idx]); },
  updateExpectedAnswer: (id, data) => { const idx = _useCases.findIndex(c => c.id === +id); if (idx >= 0) _useCases[idx].expectedAnswer = typeof data === 'string' ? data : data.expectedAnswer; return mock(true); },
  delete: (id) => { const idx = _useCases.findIndex(c => c.id === +id); if (idx >= 0) _useCases.splice(idx, 1); return mock(true); },
  batchDelete: (data) => { data.caseIds?.forEach(id => { const idx = _useCases.findIndex(c => c.id === +id); if (idx >= 0) _useCases.splice(idx, 1); }); return mock(true); },
  uploadFile: (formData, scenarioId) => mock({ fileUrl: 'https://example.com/mock-file.jpg', fileName: 'mock-upload.jpg' }),
  batchImport: (data) => mock({ successCount: 5, failCount: 0, total: 5 }),
  getAttachment: (useCaseId) => mock({ fileUrl: 'https://example.com/attachment.jpg', fileName: 'attachment.jpg', fileSize: 102400 }),
  exportCases: (params) => mock(new Blob(['mock export data'], { type: 'application/vnd.ms-excel' })),
  configVisibleScenarios: (useCaseId, data) => mock(true),
  configEditableScenarios: (useCaseId, data) => mock(true),
  batchConfigVisibleScenarios: (data) => mock(true),
  batchConfigEditableScenarios: (data) => mock(true),
  getVisibleScenarios: (useCaseId) => mock([{ id: 1, name: '采购RT审核-图文' }]),
  getEditableScenarios: (useCaseId) => mock([{ id: 1, name: '采购RT审核-图文' }]),
  importExcel: (formData) => mock({ taskId: 'TASK-MOCK-001' }),
  getImportTaskStatus: (taskId) => mock({ status: 'SUCCESS', progress: 100, totalCount: 10, processedCount: 10, successCount: 10, failedCount: 0, message: '导入成功' }),
  batchUpdateBusinessScenarios: (data) => mock(true),
  batchBindJudgeSets: (data) => mock(true),
  batchBindJudgeSetsByScenario: (data) => mock(true),
  getByJudgeSet: (judgeSetId, params) => {
    const { pageNo = 1, pageSize = 10 } = params || {};
    const list = _useCases.filter(c => c.judgeSetIds?.includes(+judgeSetId));
    const start = (pageNo - 1) * pageSize;
    return mock({ total: list.length, list: list.slice(start, start + pageSize) });
  },
  unbindJudgeSet: (data) => mock(true),
  getWithAttachment: (id) => mock({ ..._useCases.find(c => c.id === +id), attachment: { fileUrl: 'https://example.com/file.jpg' } }),
  downloadTemplate: () => mock(new Blob(['template'], { type: 'application/vnd.ms-excel' })),
  autoReviewImportPreview: (formData) => mock({ previewList: [], totalCount: 0 }),
  autoReviewImportConfirm: (previewDTO) => mock({ successCount: 0 }),
  downloadAutoReviewImportTemplate: () => mock(new Blob(['template'], { type: 'application/vnd.ms-excel' })),
  getFileTypes: (caseIds) => mock(['JSON', 'TEXT', 'IMAGE']),
  getFileTypesByScenario: (scenarioId) => mock([{ text: 'JSON', value: 'JSON' }, { text: '文本', value: 'TEXT' }, { text: '图片', value: 'IMAGE' }]),
  invokeAiModel: (data) => mock({ result: '{"score": 0.92, "pass": true, "reason": "AI评分：内容符合预期答案，断言通过"}' }),
};

let _judgeScenarioId = 40;
const _judgeScenarios = [
  { id: 1, name: '采购合规-LLM评测场景', scenarioId: 1, scenarioName: '采购RT审核-图文', judgeType: 'LLM', model: 'qwen-plus', promptWord: '请判断以下采购单是否合规：${actualData}，期望结果：${expectedData}', status: 'ACTIVE', gmtCreate: '2024-10-10 10:00:00' },
  { id: 2, name: '合同要素-规则抽取场景', scenarioId: 5, scenarioName: '合同甲乙方抽取', judgeType: 'RULE', status: 'ACTIVE', gmtCreate: '2025-01-20 14:00:00' },
  { id: 3, name: '视频帧-工程断言场景', scenarioId: 3, scenarioName: '短视频暴力内容检测', judgeType: 'ENGINEERING', status: 'ACTIVE', gmtCreate: '2024-11-15 09:00:00' },
];

// 评测场景管理API
export const judgeScenarioApi = {
  getList: (params) => {
    const { pageNo = 1, pageSize = 10, name } = params || {};
    let list = [..._judgeScenarios];
    if (name) list = list.filter(j => j.name.includes(name));
    const start = (pageNo - 1) * pageSize;
    return mock({ total: list.length, list: list.slice(start, start + pageSize) });
  },
  getDetail: (id) => mock(_judgeScenarios.find(j => j.id === +id) || _judgeScenarios[0]),
  create: (data) => { const item = { id: ++_judgeScenarioId, ...data, gmtCreate: new Date().toLocaleString('zh-CN') }; _judgeScenarios.push(item); return mock(item); },
  update: (id, data) => { const idx = _judgeScenarios.findIndex(j => j.id === +id); if (idx >= 0) Object.assign(_judgeScenarios[idx], data); return mock(_judgeScenarios[idx]); },
  delete: (id) => { const idx = _judgeScenarios.findIndex(j => j.id === +id); if (idx >= 0) _judgeScenarios.splice(idx, 1); return mock(true); },
  getDocumentSchema: (data) => mock({ schema: { fields: [{ name: 'violation', type: 'boolean' }, { name: 'reason', type: 'string' }] } }),
  getModelTypes: () => mock([{ text: 'qwen-plus', value: 'qwen-plus' }, { text: 'qwen-max', value: 'qwen-max' }, { text: 'gpt-4o', value: 'gpt-4o' }]),
  aiGenerateScriptAsync: (data) => mock({ taskId: 'AI-TASK-001' }),
  aiRegenerateScript: (data) => mock({ script: 'function assert(actual, expected) { return JSON.stringify(actual) === JSON.stringify(expected); }' }),
  aiRegenerateScriptAsync: (data) => mock({ taskId: 'AI-TASK-002' }),
  aiDebugScript: (data) => mock({ result: 'PASS', output: '{"pass": true, "score": 0.95}' }),
  aiDebugScriptAsync: (data) => mock({ taskId: 'AI-TASK-003' }),
  getAsyncTaskStatus: (taskId) => mock({ status: 'SUCCESS', result: { script: 'function assert(actual, expected) { return actual.violation === expected.violation; }', debugResult: 'PASS' } }),
  getSampleUseCases: (scenarioId, limit) => mock(_useCases.filter(c => c.scenarioId === +scenarioId).slice(0, limit)),
  getFirstUseCase: (params) => mock(_useCases.find(c => c.scenarioId === +params.scenarioId) || _useCases[0]),
  aiConfirmScript: (data) => mock(true),
  aiGenerateAllScripts: (data) => mock({ successCount: 3, failCount: 0 }),
  aiGenerateAllScriptsAsync: (data) => mock({ taskId: 'AI-TASK-ALL-001' }),
  refreshTestResult: (scenarioId, testOrderNo) => mock({ status: 'SUCCESS', passRate: 0.92 }),
};

let _judgeTaskId = 50;
const _judgeTasks = [
  { id: 1, name: '采购合规评测任务-2025Q1', judgeSetId: 1, judgeSetName: '采购审核基础集-v1', judgeScenarioId: 1, judgeScenarioName: '采购合规-LLM评测场景', status: 'COMPLETED', gmtCreate: '2025-01-15 10:00:00' },
  { id: 2, name: '合同要素抽取评测-3月', judgeSetId: 2, judgeSetName: '合同要素抽取集-v2', judgeScenarioId: 2, judgeScenarioName: '合同要素-规则抽取场景', status: 'RUNNING', gmtCreate: '2025-03-10 14:00:00' },
  { id: 3, name: '视频违规检测任务-Q4', judgeSetId: 3, judgeSetName: '视频违规检测集-v1', judgeScenarioId: 3, judgeScenarioName: '视频帧-工程断言场景', status: 'PENDING', gmtCreate: '2025-03-28 09:00:00' },
  { id: 4, name: '客服QA评测-4月', judgeSetId: 4, judgeSetName: '客服QA退换货集', judgeScenarioId: 1, judgeScenarioName: '采购合规-LLM评测场景', status: 'FAILED', gmtCreate: '2025-04-01 11:00:00' },
];
const _taskExecutions = [
  { id: 'EXEC-20240316-001', taskId: 1, taskName: '采购合规评测任务-2025Q1', status: 'SUCCESS', passRate: 0.89, totalCount: 200, passCount: 178, failCount: 18, errorCount: 4, startTime: '2025-01-15 10:05:00', endTime: '2025-01-15 10:28:00', duration: 1380 },
  { id: 'EXEC-20240317-002', taskId: 1, taskName: '采购合规评测任务-2025Q1', status: 'SUCCESS', passRate: 0.92, totalCount: 200, passCount: 184, failCount: 12, errorCount: 4, startTime: '2025-02-20 14:00:00', endTime: '2025-02-20 14:22:00', duration: 1320 },
  { id: 'EXEC-20240318-003', taskId: 2, taskName: '合同要素抽取评测-3月', status: 'RUNNING', passRate: 0, totalCount: 150, passCount: 0, failCount: 0, errorCount: 0, startTime: '2025-03-10 14:05:00', endTime: null, duration: null },
];

// 评测任务管理API
export const judgeTaskApi = {
  getList: (params) => {
    const { pageNo = 1, pageSize = 10, name, status } = params || {};
    let list = [..._judgeTasks];
    if (name) list = list.filter(t => t.name.includes(name));
    if (status) list = list.filter(t => t.status === status);
    const start = (pageNo - 1) * pageSize;
    return mock({ total: list.length, list: list.slice(start, start + pageSize) });
  },
  getDetail: (id) => mock(_judgeTasks.find(t => t.id === +id) || _judgeTasks[0]),
  create: (data) => { const item = { id: ++_judgeTaskId, ...data, status: 'PENDING', gmtCreate: new Date().toLocaleString('zh-CN') }; _judgeTasks.push(item); return mock(item); },
  update: (id, data) => { const idx = _judgeTasks.findIndex(t => t.id === +id); if (idx >= 0) Object.assign(_judgeTasks[idx], data); return mock(_judgeTasks[idx]); },
  delete: (id) => { const idx = _judgeTasks.findIndex(t => t.id === +id); if (idx >= 0) _judgeTasks.splice(idx, 1); return mock(true); },
  execute: (id) => { const idx = _judgeTasks.findIndex(t => t.id === +id); if (idx >= 0) _judgeTasks[idx].status = 'RUNNING'; return mock({ executionId: 'EXEC-NEW-' + Date.now() }); },
  importResult: (id, formData) => mock({ successCount: 10 }),
};

// 评测任务执行历史API
export const judgeTaskExecutionApi = {
  getList: (params) => {
    const { pageNo = 1, pageSize = 10, taskId } = params || {};
    let list = [..._taskExecutions];
    if (taskId) list = list.filter(e => e.taskId === +taskId);
    const start = (pageNo - 1) * pageSize;
    return mock({ total: list.length, list: list.slice(start, start + pageSize) });
  },
  getDetail: (id) => mock(_taskExecutions.find(e => e.id === id) || _taskExecutions[0]),
  recalculate: (id) => mock({ passRate: 0.91 }),
};

const _caseExecutions = [
  { id: 1, taskExecutionHistoryId: 'EXEC-20240316-001', caseId: 1, caseName: '采购单-金额超限用例', status: 'PASS', actualOutput: '{"violation": true, "reason": "金额超过审批阈值且审批人为空"}', expectedOutput: '{"violation": true, "reason": "金额超过审批阈值且审批人为空"}', score: 1.0, assertResult: 'PASS', gmtCreate: '2025-01-15 10:08:00' },
  { id: 2, taskExecutionHistoryId: 'EXEC-20240316-001', caseId: 2, caseName: '采购单-正常合规用例', status: 'PASS', actualOutput: '{"violation": false}', expectedOutput: '{"violation": false}', score: 1.0, assertResult: 'PASS', gmtCreate: '2025-01-15 10:09:00' },
  { id: 3, taskExecutionHistoryId: 'EXEC-20240316-001', caseId: 3, caseName: '合同-甲乙方标准抽取', status: 'FAIL', actualOutput: '{"party_a": "阿里巴巴有限公司", "party_b": "浙江XX科技"}', expectedOutput: '{"party_a": "阿里巴巴（中国）有限公司", "party_b": "浙江XX科技有限公司"}', score: 0.6, assertResult: 'FAIL', gmtCreate: '2025-01-15 10:10:00' },
];

// 用例执行历史API
export const useCaseExecutionApi = {
  getList: (params) => {
    const { pageNo = 1, pageSize = 10, taskExecutionHistoryId } = params || {};
    let list = [..._caseExecutions];
    if (taskExecutionHistoryId) list = list.filter(e => e.taskExecutionHistoryId === taskExecutionHistoryId);
    const start = (pageNo - 1) * pageSize;
    return mock({ total: list.length, list: list.slice(start, start + pageSize) });
  },
  parseAleResult: (aleResultJson) => mock({ parsedResult: { pass: true, score: 0.9, details: [] } }),
  updateMarkResult: (data) => mock(true),
  getPassRate: (taskExecutionHistoryId, totalCount) => mock({ totalCount: totalCount || 200, passCount: 178, failCount: 18, passRate: 89.0 }),
  downloadReport: (taskExecutionHistoryId) => mock(new Blob(['report data'], { type: 'application/vnd.ms-excel' })),
  uploadReport: (taskExecutionHistoryId, file) => mock({ successCount: 10 }),
  parseMarkingUrl: (scenarioId, caseId, executionHistoryId) => mock('https://example.com/marking?caseId=' + caseId),
};

let _benchmarkId = 60;
const _benchmarks = [
  { id: 1, benchmarkVersion: 'v1.0.0', benchmarkType: '基线benchmark', businessScenarioName: '采购RT审核-图文', useCaseCount: 200, description: '2024年Q4基线', gmtCreate: '2024-12-01 10:00:00' },
  { id: 2, benchmarkVersion: 'v2.0.0', benchmarkType: '样本验收benchmark', businessScenarioName: '合同甲乙方抽取', useCaseCount: 150, description: '2025年Q1验收版', gmtCreate: '2025-01-20 14:00:00' },
  { id: 3, benchmarkVersion: 'v1.5.0', benchmarkType: '线上周期评测benchmark', businessScenarioName: '短视频暴力内容检测', useCaseCount: 320, description: '线上稳定性周期测评', gmtCreate: '2025-02-10 09:00:00' },
];

// Benchmark管理API
export const benchmarkApi = {
  getList: (params) => {
    const { pageNo = 1, pageSize = 10, benchmarkVersion } = params || {};
    let list = [..._benchmarks];
    if (benchmarkVersion) list = list.filter(b => b.benchmarkVersion.includes(benchmarkVersion));
    const start = (pageNo - 1) * pageSize;
    return mock({ total: list.length, list: list.slice(start, start + pageSize) });
  },
  getDetail: (id) => mock(_benchmarks.find(b => b.id === +id) || _benchmarks[0]),
  create: (data) => { const item = { id: ++_benchmarkId, ...data, gmtCreate: new Date().toLocaleString('zh-CN') }; _benchmarks.push(item); return mock(item); },
  update: (id, data) => { const idx = _benchmarks.findIndex(b => b.id === +id); if (idx >= 0) Object.assign(_benchmarks[idx], data); return mock(_benchmarks[idx]); },
  delete: (id) => { const idx = _benchmarks.findIndex(b => b.id === +id); if (idx >= 0) _benchmarks.splice(idx, 1); return mock(true); },
  addCases: (id, data) => mock(true),
  uploadFile: (formData) => mock({ fileUrl: 'https://example.com/mock-file.pdf', fileName: 'mock.pdf' }),
  getMetricsByExecutionHistory: (historyId) => mock([
    { id: 1, metricName: '合规性得分', metricKey: 'compliance_score', weight: 0.5 },
    { id: 2, metricName: '完整性得分', metricKey: 'completeness_score', weight: 0.3 },
    { id: 3, metricName: '准确性得分', metricKey: 'accuracy_score', weight: 0.2 },
  ]),
};

// 标注结果管理API
export const annotationApi = {
  getList: (params) => mock({ total: 0, list: [] }),
  getDetail: (id) => mock(null),
  import: (formData) => mock({ successCount: 5 }),
  batchUpdate: (formData) => mock(true),
};

// Benchmark指标管理API
export const benchmarkMetricApi = {
  getList: (params) => mock({ total: 3, list: [
    { id: 1, metricName: '合规性得分', metricKey: 'compliance_score', weight: 0.5, description: '评测内容合规性' },
    { id: 2, metricName: '完整性得分', metricKey: 'completeness_score', weight: 0.3, description: '评测信息完整性' },
    { id: 3, metricName: '准确性得分', metricKey: 'accuracy_score', weight: 0.2, description: '评测结果准确性' },
  ]}),
  getDetail: (id) => mock({ id, metricName: '合规性得分', metricKey: 'compliance_score', weight: 0.5 }),
  create: (data) => mock({ id: Date.now(), ...data }),
  update: (id, data) => mock({ id, ...data }),
  delete: (id) => mock(true),
};

// 评测场景指标管理API
export const scenarioMetricApi = {
  getListByScenarioId: (scenarioId) => mock([
    { id: 1, metricName: '断言通过率', metricKey: 'pass_rate', scenarioId, weight: 1.0 },
    { id: 2, metricName: 'LLM评分均值', metricKey: 'llm_avg_score', scenarioId, weight: 0.8 },
  ]),
  getConfig: (scenarioId) => mock({
    presetMetrics: [{ id: 1, metricName: '断言通过率', metricKey: 'pass_rate', weight: 1.0 }],
    customMetrics: [{ id: 2, metricName: 'LLM评分均值', metricKey: 'llm_avg_score', weight: 0.8 }],
  }),
  saveConfig: (scenarioId, data) => mock(true),
  create: (data) => mock({ id: Date.now(), ...data }),
  update: (id, data) => mock({ id, ...data }),
  delete: (id) => mock(true),
};

// ============================================
// Dashboard 工作台首页统计接口
// ============================================
export const dashboardApi = {
  getOverviewStats: () => mock({ totalDomains: 5, totalScenarios: 8, totalUseCases: 750 }),
  getTaskStats: () => mock({ totalTasks: 12, totalBenchmarks: 3, runningTasks: 1, completedTasks: 9, failedTasks: 1, pendingTasks: 1, successRate: 90.0, avgExecutionTime: 1350 }),
  getTaskStatusDistribution: () => mock({ distribution: [
    { status: '执行成功', count: 9, color: '#22c55e' },
    { status: '执行中', count: 1, color: '#f59e0b' },
    { status: '执行失败', count: 1, color: '#ef4444' },
    { status: '待执行', count: 1, color: '#94a3b8' },
  ]}),
  getDomainRadar: () => mock({ radarData: [
    { domain: '内容审核-图文', scenarios: 80, tasks: 70, success: 89, benchmarks: 60 },
    { domain: '内容审核-视频', scenarios: 60, tasks: 50, success: 75, benchmarks: 40 },
    { domain: '采购合规审核', scenarios: 50, tasks: 40, success: 92, benchmarks: 30 },
    { domain: '合同要素抽取', scenarios: 70, tasks: 60, success: 85, benchmarks: 50 },
    { domain: '智能客服QA', scenarios: 40, tasks: 30, success: 78, benchmarks: 20 },
  ]}),
  getCaseExecutionStats: () => mock({ executionStats: [
    { status: '断言通过', count: 538, color: '#22c55e', percentage: 71.7 },
    { status: '断言不通过', count: 176, color: '#ef4444', percentage: 23.5 },
    { status: '执行异常', count: 36, color: '#f59e0b', percentage: 4.8 },
  ], passRate: 71.7 }),
  getBenchmarkEvolution: (params) => mock({ total: 3, benchmarks: _benchmarks }),
  getScenarioCategoryStats: () => mock({ totalScenarios: 8, categoryStats: [
    { category: '要素抽取', categoryKey: 'FEATURE_EXTRACTION', scenarioCount: 3, judgeSetCount: 2, useCaseCount: 250, taskCount: 4, passRate: 87.5 },
    { category: '机审', categoryKey: 'AUTO_REVIEW', scenarioCount: 3, judgeSetCount: 2, useCaseCount: 320, taskCount: 5, passRate: 89.0 },
    { category: '机器人问答', categoryKey: 'ROBOT_QA', scenarioCount: 2, judgeSetCount: 1, useCaseCount: 180, taskCount: 3, passRate: 78.3 },
  ]}),
};

// 用户信息查询
export const userApi = {
  getUserInfo: () => mock({ userId: 'james001', userName: '冯周充', empId: 'EMP-001', avatarUrl: '', role: 'ADMIN' }),
  logoutAdminUser: () => mock(true),
  getUserRole: (domainId, scenarioId) => mock(3), // 3 = DOMAIN_ADMIN，拥有全部权限
  checkScenarioAdmin: (scenarioId) => mock(true),
};

// 影子链路API
export const shadowLinkApi = {
  getReportList: (params) => {
    const { pageNum = 1, pageSize = 10 } = params || {};
    const list = [
      { id: 1, domain: '采购', scenario: '采购RT审核-shadow', reportTime: '2025-03-01 10:00:00', totalCount: 1200, hitCount: 87, hitRate: 7.25, status: 'COMPLETED' },
      { id: 2, domain: '合同', scenario: '合同机审-shadow', reportTime: '2025-03-05 14:00:00', totalCount: 850, hitCount: 34, hitRate: 4.0, status: 'COMPLETED' },
      { id: 3, domain: '财务', scenario: '财务审核-shadow', reportTime: '2025-03-10 09:00:00', totalCount: 640, hitCount: 22, hitRate: 3.44, status: 'COMPLETED' },
    ];
    return mock({ total: list.length, list });
  },
  getReportStats: (params) => mock({ totalReports: 3, totalHitCount: 143, avgHitRate: 4.9 }),
  getReportDetail: (id) => mock({ id, domain: '采购', scenario: '采购RT审核-shadow', hitItems: ['金额超限', '审批缺失', '供应商未备案'] }),
  exportReport: (params) => mock(new Blob(['report'], { type: 'application/vnd.ms-excel' })),
  getEvaluationList: (params) => {
    const list = [
      { id: 1, domain: '采购', scenario: '采购RT审核-shadow', evalTime: '2025-03-08 11:00:00', passRate: 88.5, totalCount: 200, passCount: 177, status: 'SUCCESS' },
      { id: 2, domain: '合同', scenario: '合同机审-shadow', evalTime: '2025-03-12 15:00:00', passRate: 79.3, totalCount: 150, passCount: 119, status: 'SUCCESS' },
    ];
    return mock({ total: list.length, list });
  },
  getEvaluationStats: (params) => mock({ totalEvals: 2, avgPassRate: 83.9, latestPassRate: 79.3 }),
  getEvaluationTrend: (params) => mock({ trend: [
    { date: '2025-01', passRate: 75.0 },
    { date: '2025-02', passRate: 82.0 },
    { date: '2025-03', passRate: 88.5 },
  ]}),
  getEvaluationDetail: (id) => mock({ id, passRate: 88.5, details: [] }),
  exportEvaluation: (id) => mock(new Blob(['eval'], { type: 'application/vnd.ms-excel' })),
  getBusinessDomains: () => mock({ list: [{ value: '采购', label: '采购' }, { value: '合同', label: '合同' }, { value: '财务', label: '财务' }] }),
  getBusinessScenarios: (domain) => mock({ list: [
    { value: '采购RT审核-shadow', label: '采购RT审核-shadow' },
    { value: '合同机审-shadow', label: '合同机审-shadow' },
  ].filter(s => !domain || s.value.includes(domain)) }),
  getAssertionConfigList: (params) => mock({ total: 2, list: [
    { id: 1, ruleName: '金额超限断言', domainId: 3, scenarioId: 4, assertionType: 'ENGINEERING', enabled: 'Y', description: '采购金额超过100万触发', gmtCreate: '2025-02-01 10:00:00' },
    { id: 2, ruleName: '合规性LLM断言', domainId: 1, scenarioId: 1, assertionType: 'LLM', enabled: 'Y', judgeModel: 'qwen-plus', description: 'LLM评估合规性', gmtCreate: '2025-02-15 14:00:00' },
  ]}),
  createAssertionConfig: (data) => mock({ id: Date.now(), ...data }),
  updateAssertionConfig: (data) => mock(data),
  deleteAssertionConfig: (id) => mock(true),
  toggleAssertionConfig: (id, enabled) => mock(true),
  copyAssertionConfig: (id) => mock(id + 100),
  getAssertionConfigStats: () => mock({ engineeringCount: 1, llmCount: 1, enabledCount: 2, myCount: 2 }),
};

// =============================================
// 评测数据洞察 Mock 数据
// =============================================

// 生成过去N个月的月份标签，如 ['2025-10', '2025-11', ..., '2026-04']
const _genMonths = (count = 7) => {
  const result = [];
  const now = new Date();
  for (let i = count - 1; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    result.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
  }
  return result;
};

// 生成过去N天内随机分布的日期点（模拟Benchmark执行时间戳）
const _genDatePoints = (count = 12, daysBack = 90) => {
  const result = [];
  const now = Date.now();
  const used = new Set();
  while (result.length < count) {
    const offset = Math.floor(Math.random() * daysBack);
    const d = new Date(now - offset * 86400000);
    const key = d.toISOString().slice(0, 10);
    if (!used.has(key)) {
      used.add(key);
      result.push(key);
    }
  }
  return result.sort();
};

// 机审场景 benchmark 水位数据（3个维度，各5个指标）
const _genWatermarkData = (datePoints, scenarioIndex = 0) => {
  const base = [0.72, 0.78, 0.81][scenarioIndex % 3];
  return datePoints.map((date, i) => {
    const noise = () => +(Math.random() * 0.08 - 0.04).toFixed(4);
    return {
      date,
      benchmarkId: (i % 3) + 1,  // 映射到 _benchmarks 已有的 id 1~3
      benchmarkName: `Benchmark-v${(i + 1).toString().padStart(2, '0')}`,
      // 第一个点=基线，第二个点=评估验收，后续全部为线上周期
      setCategory: i === 0 ? 'BASELINE' : i === 1 ? 'ACCEPTANCE' : 'PERIODIC',
      // 单据维度
      doc_no_risk_precision: +(base + 0.05 + noise()).toFixed(4),
      doc_no_risk_recall: +(base + 0.03 + noise()).toFixed(4),
      doc_risk_precision: +(base - 0.02 + noise()).toFixed(4),
      doc_risk_recall: +(base - 0.05 + noise()).toFixed(4),
      doc_accuracy: +(base + 0.04 + noise()).toFixed(4),
      // 规则平均维度
      rule_avg_no_risk_precision: +(base + 0.03 + noise()).toFixed(4),
      rule_avg_no_risk_recall: +(base + 0.01 + noise()).toFixed(4),
      rule_avg_risk_precision: +(base - 0.03 + noise()).toFixed(4),
      rule_avg_risk_recall: +(base - 0.06 + noise()).toFixed(4),
      rule_avg_accuracy: +(base + 0.02 + noise()).toFixed(4),
      // 规则明细维度
      rule_detail_no_risk_precision: +(base + 0.02 + noise()).toFixed(4),
      rule_detail_no_risk_recall: +(base + 0.00 + noise()).toFixed(4),
      rule_detail_risk_precision: +(base - 0.04 + noise()).toFixed(4),
      rule_detail_risk_recall: +(base - 0.07 + noise()).toFixed(4),
      rule_detail_accuracy: +(base + 0.01 + noise()).toFixed(4),
    };
  });
};

// 样本使用月度数据（旧版，保留兼容）
const _genSampleUsageData = (months, scenarioIndex = 0) => {
  const baseTotal = [450, 620, 380][scenarioIndex % 3];
  return months.map((month, i) => {
    const total = baseTotal + Math.floor(Math.random() * 50);
    const used = Math.floor(total * (0.45 + i * 0.03 + Math.random() * 0.1));
    return {
      month,
      totalSamples: total,
      usedSamples: Math.min(used, total),
      usageRate: +(Math.min(used, total) / total * 100).toFixed(1),
    };
  });
};

// 样本使用月度数据（按评估类型分组）
const _genSampleUsageByCategory = (months, scenarioIndex = 0) => {
  const baseTotals = {
    BASELINE: [180, 250, 150][scenarioIndex % 3],
    ACCEPTANCE: [120, 180, 100][scenarioIndex % 3],
    PERIODIC: [150, 190, 130][scenarioIndex % 3],
  };
  return months.map((month, i) => {
    const byCategory = {};
    ['BASELINE', 'ACCEPTANCE', 'PERIODIC'].forEach(cat => {
      const base = baseTotals[cat];
      const total = base + Math.floor(Math.random() * 30);
      const used = Math.floor(total * (0.4 + i * 0.04 + Math.random() * 0.15));
      byCategory[cat] = {
        totalSamples: total,
        usedSamples: Math.min(used, total),
        usageRate: +(Math.min(used, total) / total * 100).toFixed(1),
      };
    });
    return { month, byCategory };
  });
};

// 预生成各场景数据（场景id -> 数据）
const _insightDataCache = {};
const _getInsightData = (scenarioId) => {
  if (!_insightDataCache[scenarioId]) {
    const datePoints = _genDatePoints(14, 90);
    const months = _genMonths(7);
    const idx = scenarioId % 3;
    _insightDataCache[scenarioId] = {
      watermark: _genWatermarkData(datePoints, idx),
      sampleUsage: _genSampleUsageData(months, idx),
      sampleUsageByCategory: _genSampleUsageByCategory(months, idx),
    };
  }
  return _insightDataCache[scenarioId];
};

export const dataInsightApi = {
  // 获取效果水位趋势数据（左图）
  getWatermarkTrend: (params) => {
    const { scenarioId, startDate, endDate } = params || {};
    const data = _getInsightData(scenarioId || 1);
    let list = [...data.watermark];
    if (startDate) list = list.filter(d => d.date >= startDate);
    if (endDate) list = list.filter(d => d.date <= endDate);
    return mock({ scenarioId, list });
  },

  // 获取样本使用情况数据（右图，旧版）
  getSampleUsage: (params) => {
    const { scenarioId, startMonth, endMonth } = params || {};
    const data = _getInsightData(scenarioId || 1);
    let list = [...data.sampleUsage];
    if (startMonth) list = list.filter(d => d.month >= startMonth);
    if (endMonth) list = list.filter(d => d.month <= endMonth);
    return mock({ scenarioId, list });
  },

  // 获取样本使用情况数据（右图，按评估类型分组）
  getSampleUsageByCategory: (params) => {
    const { scenarioId, startMonth, endMonth } = params || {};
    const data = _getInsightData(scenarioId || 1);
    let list = [...data.sampleUsageByCategory];
    if (startMonth) list = list.filter(d => d.month >= startMonth);
    if (endMonth) list = list.filter(d => d.month <= endMonth);
    return mock({ scenarioId, list });
  },

  // 获取该项目空间下可选的业务场景列表（含场景类型）
  getScenarioList: (domainId) => {
    const scenarioMap = {
      1: [
        { id: 101, name: '图文内容机审-通用', type: 'MACHINE_AUDIT', domainId: 1 },
        { id: 102, name: '图文内容机审-直播', type: 'MACHINE_AUDIT', domainId: 1 },
      ],
      2: [
        { id: 201, name: '视频帧级违规检测', type: 'MACHINE_AUDIT', domainId: 2 },
      ],
      3: [
        { id: 301, name: '采购单合规机审', type: 'MACHINE_AUDIT', domainId: 3 },
        { id: 302, name: '发票真实性校验', type: 'MACHINE_AUDIT', domainId: 3 },
        { id: 303, name: '采购金额合规检查', type: 'MACHINE_AUDIT', domainId: 3 },
      ],
      4: [
        { id: 401, name: '合同甲乙方抽取', type: 'ELEMENT_EXTRACTION', domainId: 4 },
        { id: 402, name: '合同金额日期抽取', type: 'ELEMENT_EXTRACTION', domainId: 4 },
      ],
      5: [
        { id: 501, name: '售后QA意图识别', type: 'MACHINE_AUDIT', domainId: 5 },
      ],
    };
    const list = scenarioMap[+domainId] || scenarioMap[1];
    return mock({ list });
  },
};

export default {};


